import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "../../components/participant/profile-page";

/** `/me` — a participant's profile (the `_app` guard keeps everyone else off it). */
export const Route = createFileRoute("/_app/me/")({
	component: ProfilePage,
});
